var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFont(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 19.5V17.5H12V19.5H1Z",
    fill: "#505050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.272 5.076H7.4L11.8 16.5H9.656L8.584 13.476H4.024L2.952 16.5H0.888L5.272 5.076ZM4.568 11.956H8.056L6.344 7.044H6.296L4.568 11.956Z",
    fill: "#505050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFont);
export default __webpack_public_path__ + "static/media/font.82451cb7569b32393c44a248d2b3099f.svg";
export { ForwardRef as ReactComponent };